<template>
  <div v-if="items.length" class="title-dropdown-menu" @click.stop="toggleDropdown()">
    <div class="title-dropdown-menu__icon" ></div>
    <div class="title-dropdown-menu__overlay"
         v-if="isDropdownStatusVisible"
         @click.stop="toggleDropdown()"
    ></div>
    <ul class="title-dropdown-menu__list" v-if="isDropdownStatusVisible">
      <li class="title-dropdown-menu__item"
          v-for="item in items"
          :key="item.id"
          @click.stop="onValueSelected(item)"
      >
        <img v-if="['asana'].includes(item.id)"
             class="title-dropdown-menu__integration-logo"
             :src="require(`@/assets/integrations_logos/${item.id}-logo.svg`)"/>
        <base-material-design-icon v-else class="title-dropdown-menu__item-icon" :icon="item.id" :size="parseInt('48')"/>
        <span class="title-dropdown-menu__item-label">{{item.label}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import ContentBrief from './index'
import _ from 'lodash'

/**
 * Overflow menu at the top right coroner of content brief {@link ContentBrief}
 */
export default {
  name: 'TitleDropdownMenu',
  props: {
    isAsanaIntegrated: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      items: _.cloneDeep(this.options),
      isDropdownStatusVisible: false
    }
  },
  created () {
    this.setMenuItems()
  },
  methods: {
    onValueSelected (item) {
      this.toggleDropdown()
      this.$emit('menuItem', item.id)
    },
    toggleDropdown: function () {
      this.isDropdownStatusVisible = !this.isDropdownStatusVisible
    },
    setMenuItems: function () {
      const items = _.cloneDeep(this.options)
      if (!this.options.length && ((this.isCurrentUserClientCollaborator && this.isAsanaIntegrated) || !this.isCurrentUserClientCollaborator)) {
        items.unshift({
          label: this.isAsanaIntegrated ? 'Open Associated Asana Task' : 'Add To Asana',
          id: 'asana'
        })
      }

      this.items = items
    }
  },
  watch: {
    isCurrentUserClientCollaborator: function () {
      this.setMenuItems()
    }
  }
}
</script>

<style lang="scss">
  .title-dropdown-menu {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &__integration-logo {
      width: 16px;
    }

    &__item-icon {
      font-size: 16px;
    }
    &__icon {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: $rfx-dark-march;
      position: relative;

      &:after,
      &:before {
        content: '';
        position: absolute;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: $rfx-dark-march;
        top: -6px;
      }
      &:after {
        top: 6px;
      }
    }

    &__list {
      position: absolute;
      z-index: 1001;
      list-style-type: none;
      margin: 0;
      padding: 0;
      background-color: #fff;
      border-radius: 8px;
      -webkit-box-shadow: 0 16px 48px -16px rgba(8, 8, 8, .24);
      box-shadow: 0 0 1px 0 rgba(8, 8, 8, .24), 0 4px 15px 0 rgba(8, 8, 8, .24);
      max-height: 475px;
      overflow-y: auto;
      font-weight: 400;
      right: 0;
      top: 35px;
    }

    &__overlay {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
    }

    &__item {
      display: flex;
      padding: 0 30px;
      height: 30px;
      line-height: 30px;
      color: #000;
      font-size: 12px;
      cursor: pointer;
      @include ellipsis;

      &_active,
      &:hover {
        background-color: $rfx-bright-blue;
        color: #fff;
      }
    }

    &__item-label{
      margin-left: 10px;
    }
  }

</style>
